export function formatCancelTranslateImage(options) {
  let { width, height, left, top, scaleX, scaleY } = options;
  width *= scaleX;
  height *= scaleY;
  left = left <= 0 ? 0 : left;
  top = top <= 0 ? 0 : top;
  return { width, height, top, left };
}

export const setImageObject = ({ object, uid, commit, state, context }) => {
  let startModify = false;
  object.on('mousedown', e => {
    startModify = true;
    commit('SET_SELECTED_OBJECT_UID', uid);
    // console.log(11111111111, 'mousedown');
    if (!state.isGrouping) {
      context.dispatch('setCurrentPropsEditorType', 'image');
    }
  });
  object.on('mouseup', e => {
    startModify = false;
    // console.log(3333333, 'mouseup');
  });
  object.on('mousemove', function (e) {
    if (!startModify) return;
    // console.log(2222222, 'mousemove');
    // canvas向store绑定
    const { width, height, top, left } = formatCancelTranslateImage(e.target);
    object.set({ left, top, width, height, cropX: left, cropY: top, zoomX: 1, zoomY: 1 });
    // console.log(1111111, { width, height, left, top });
    context.dispatch('updateSelectedObjectFromCanvas', {
      width,
      height,
      left,
      top,
      cropX: left,
      cropY: top,
      scaleX: 1,
      scaleY: 1,
    });
  });
};
